import SvgIcon from '@mui/material/SvgIcon';

export const DPAPWikiIcon = () => (
  <SvgIcon
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z"
      fill="#454B4C"
    />
    <path
      d="M33.9547 45.8445C42.2411 42.0622 48 33.7036 48 24C48 10.7452 37.2548 0 24 0C21.784 0 19.638 0.300343 17.6008 0.862544L33.9547 45.8445Z"
      fill="#32BBEC"
    />
  </SvgIcon>
);
